<style>
table thead th {
  background-color: rgb(26, 54, 101) !important;
  color: white;
}
</style>
<template>
  <CCard>
    <CCardHeader style="background:#1a3665;color:white" 
    class="d-flex align-items-center font-weight-bold">Master Test Center     
      <template v-if="role_status && role_status.status_create">
        <CButton 
        to="/data-master/data-test-center-tambah"
        color="success"
        style="float:right;margin-right:10px "
        class="btn-md ml-auto"
        >Tambah</CButton>
      </template>
      <template v-else>
        <CButton 
        color="readonly"
        style="float:right;margin-right:10px "
        class="btn-md ml-auto"
        disabled
        >Tambah</CButton>
      </template>
    
    </CCardHeader>

    <CCardBody>
      <CRow>
        <CCol xl="12">
          <CSelect
            label="Data Perhalaman"
            class="float-left"
            @change="changePageSize"
            :options="[10, 25, 100, 'Semua Data']"
          />
          <CInput
            label="Pencarian"
            class="float-right"
            placeholder="Cari Data .."
            v-model="search"
          />
          <br />
        </CCol>        
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #kodeTc="{item}">
              <td class="py-2 font-weight-bold">{{ item.kodeTc ? item.kodeTc : '-' }}</td>
            </template>
            <template #namaTc="{item}">
              <td class="py-2">{{ item.namaTc ? item.namaTc : '-' }}</td>
            </template>
            <template #email="{item}">
              <td class="py-2">{{ item.email ? item.email : '-' }}</td>
            </template>
            <template #alamat="{item}">
              <td class="py-2">{{ item.alamat ? item.alamat : '-' }}</td>
            </template>
            <template #telpOperator="{item}">
              <td class="py-2">{{ item.telpOperator ? item.telpOperator : '-' }}</td>
            </template>
            <template #telpTc="{item}">
              <td class="py-2">{{ item.telpTc ? item.telpTc : '-' }}</td>
            </template>
            <template #operator="{item}">
              <td class="py-2">{{ item.operator ? item.operator : '-' }}</td>
            </template>
            <template #status="{item}">
              <td class="py-2 text-left">
                <p  v-if="item.status == 1" class="text-success font-weight-bold"> Aktif</p>
                <p  v-else class="text-danger font-weight-bold"> Tidak Aktif</p>
              </td>
            </template>
            <template #aksi="{item, index}">
              <td class="py-2 text-center d-flex align-items-center">
                <template v-if="role_status && role_status.status_read">
                  <CButton v-c-tooltip="'Lihat Petugas Test Center'" color="success" square size="sm" style="margin-right:8px" @click="getPetugasTcByIdTc(item.idTc)">
                    <font-awesome-icon icon="eye" />
                  </CButton>&nbsp;&nbsp;
                </template>
                <template v-else>
                  <CButton v-c-tooltip="'Lihat Petugas Test Center'" color="secondary" square size="sm" style="margin-right:8px" disabled>
                    <font-awesome-icon icon="eye" />
                  </CButton>&nbsp;&nbsp;
                </template>
                <template v-if="role_status && role_status.status_update">
                  <router-link
                    :to="'/data-master/data-test-center-edit/'+item.idTc"
                    class="btn btn-sm btn-info mr-2"
                    square
                    v-c-tooltip="'Ubah'"
                  >
                    <font-awesome-icon icon="edit" />
                  </router-link>&nbsp;
                </template>
                <template v-else>
                  <CButton v-c-tooltip="'edit'" color="secondary" square size="sm" style="margin-right:8px" disabled>
                    <font-awesome-icon icon="edit" />
                  </CButton>&nbsp;
                </template>
                <template v-if="role_status && role_status.status_delete">
                  <CButton v-c-tooltip="'Hapus'" color="danger" square size="sm" @click="deleteData(item, index)">
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </template>
                <template v-else>
                  <CButton v-c-tooltip="'Hapus'" color="secondary" square size="sm" disabled>
                    <font-awesome-icon icon="trash" />
                  </CButton>
                </template>
              </td>
            </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPage"
            :pages="pagination.totalPages"
            responsive
            @click="pageChange"
          />
        </CCol>
      </CRow>
    </CCardBody>
    <CModal
        title="Modal title"
        :show.sync="modalPetugasTc"
        size="lg"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm v-on:submit.prevent="postData">
          <CRow>
            <div class="modal-body mt-n4">
              <form>                
                <div class="form-group">
                    <CDataTable style="widht:100% !important" :items="itemsPetugasTc" :fields="fieldsPetugas" hover>
                      <template #no="{index}">
                        <td class="py-2">{{ index += 1}}</td>
                      </template>
                    </CDataTable>
                </div>
              </form>
            </div>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Petugas Test Center</h6>
        </template>
        <template #footer>
          <CButton @click="modalPetugasTc = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
  </CCard>
</template>

<script>
const fields = [
  { key: "no" },
  {
    key: "kodeTc",
    label: "Kode",
    _style: 'width: 6rem'
  },
  { key: "namaTc", label: "Nama" },
  { key: "email" },
  { key: "alamat" },
  {
    key: "telpTc",
    label: "Telepon"
  },
 
  {
    key: "status",
    label: "Status",
    _style: "text-align: center"
  },
  {
    key: "aksi",
    _style: "width:12%; text-align: center"   
  }
];

import DataTestCenterServices from "../../services/datamaster/data-test-center.service";
import PetugasTcService from "../../services/user-manajemen/petugas-tc.service";
import {AlertUtils} from "../../mixins/AlertUtils"
import { exportUtils } from '../../mixins/exportUtils';

const fieldsPetugas = [
  {
    key: "no",
    label: "No",
    sorter: false,
    filter: false
  },
  {
    key: "name",
    label: "Nama",
    _classes: 'text-center',
    sorter: true,
    filter: false
  },
  {
    key: "username",
    label: "Username",
    _classes: 'text-center',
    sorter: true,
    filter: false
  },
  {
    key: "email",
    label: "Email",
    _classes: 'text-center',
    sorter: true,
    filter: false
  },
  {
    key: "no_telp",
    label: "Nomor Telepon",
    _classes: 'text-center',
    sorter: true,
    filter: false
  }
];

export default {
  name: "DataTestCenter",
  mixins : [
    AlertUtils,
    exportUtils
  ],

  data() {
    return {
      itemsPetugasTc: [],
      fieldsPetugas,
      items: [],
      modalPetugasTc : false,
      search: "",
      pageSize: "10",
      fields,
      pagination: {
        totalPages: 0
      },
      currentPage: 0,
      details: [],
      no: 1,
      status: false,
      myModal: false,
      horizontal: { label: "col-3", input: "col-9" },
      indexed: 0,
      collapseDuration: 0,
      content: [],
      timeout : null,

      loading: true,
      role_status: null
    };
  },
  computed: {
    // ...mapState('request', ['data'] ),
    data() {
      return this.$store.state.request.data;
    }
  },
  watch: {
    search: function (val) {
       clearTimeout(this.timeout);
      var vm = this
      this.timeout = setTimeout(function () {
          // enter this block of code after 1 second
          // handle stuff, call search API etc.
          vm.getData("0", vm.pageSize, vm.search);
      }, 1000);
    },
    currentPage: function(val) {
      // alert(val-1);
      var page = val - 1;
      this.indexed = page * 10;
      // alert(this.indexed);
      this.getData(val - 1, this.pageSize, this.search);
      // this.getData(val-1);
    }
  },
  mounted() {
    this.roleData()
    this.getData("0", this.pageSize, "default");
    // this.$store.dispatch("request/getDataTestCenter");
  },
  methods: {
    getPetugasTcByIdTc(idTc) {
      this.modalPetugasTc = true;
      PetugasTcService.getPetugasTcByIdTc(idTc)
      .then(response => {
        // comment console console.log(response);
        this.itemsPetugasTc = response.data.data;
      }).catch(error => {
        // comment console console.log(error)
      })
    },
    pageChange() {
      this.getData(currentPage);
    },
 
    changePageSize(e) {
      // comment console console.log(e.target.value);
      var pageSize = "";

      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
      this.getData("0", pageSize, this.search);
    },
  
    deleteData(item, index) {
      var vm = this;
      this.formData = item;
      this.$swal
        .fire({
          title: "Peringatan!",
          text: "Apakah anda yakin ingin menghapus data ini ?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Ya",
          cancelButtonText: "Tidak",
          confirmButtonColor: "#d33",
          cancelButtonColor: "#3085d6",
          reverseButtons: true
        })
        .then(result => {
          if (result.value) {
            let loader = this.$loading.show({
              container: false ? null : this.$refs.formContainer,
              canCancel: true,
              onCancel: this.onCancel
            });
            DataTestCenterServices.deleteDataTestCenter(item.idTc)
              .then(response => {
                // comment console console.log(response);
                loader.hide();
                vm.alertDeleteSuccess();
                vm.getData("0", 10, this.search);
              })
              .catch(error => {
                vm.alertError();
                // comment console console.log(error);
              });
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            vm.$swal.fire(
              "Cancelled",
              "Your imaginary file is safe :)",
              "error"
            );
          }
        });
    },
    getBadge(status) {
      switch (status) {
        case "Active":
          return "success";
        case "Inactive":
          return "secondary";
        case "Pending":
          return "warning";
        case "Banned":
          return "danger";
        default:
          "primary";
      }
    },
    toggleDetails(item) {
      this.$set(this.items[item.id], "_toggled", !item._toggled);
      this.collapseDuration = 300;
      this.$nextTick(() => {
        this.collapseDuration = 0;
      });
    },

    getData(currentPage, pageSize, filter) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      DataTestCenterServices.getDataTestCenter(currentPage, pageSize, filter)
        .then(response => {
          loader.hide();
          // comment console console.log(response.data.data.content);
          this.items = response.data.data.content;
          this.pagination.totalPages = response.data.data.totalPages;
          this.currentPage = response.data.data.pageable.pageNumber + 1;
        })
        .catch(error => {
          // comment console console.log(error);
        });
    },

    exportDataTestCenter() {
      DataTestCenterServices.exportDataTestCenter()
        .then(response => {          
          this.exportData(response.data, 'TestCenter')
          this.alertExportSuccess();
          this.getData("0", "10", "default");
        })
        .catch(error => {
          // comment console console.log(error)
          this.alertExportFailed();
          this.getData("0", "10", "default");
        })
    },
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === this.$route.path );  
      this.role_status = data;
    }
   
  }
};
</script>